import { FULL_PAGE_CHAT, FULL_PAGE_CHAT_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const chatRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: FULL_PAGE_CHAT_PAGE,
	path: FULL_PAGE_CHAT,
	layout: 'home',
	nav4Layout: 'expanded',
	query: [
		'rovoChat!=false',
		'rovoChat.agentId!=false',
		'rovoChat.cloudId!=false',
		'rovoChat.conversationId!=false',
		'rovoChat.pathway!=false',
		'rovoChat.prompt!=false',
		'rovoChat!=false',
		'rovoChatAgentId!=false',
		'rovoChatCloudId!=false',
		'rovoChatConversationId!=false',
		'rovoChatPathway!=false',
		'rovoChatPrompt!=false',
		'rovoChatTriggerOpen!=false',
	],
});
